import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";

// This method redirect to Home Page

export default /*#__PURE__*/_defineComponent({
  __name: 'page-not-found',
  setup(__props, { expose: __expose }) {
  __expose();


const handleBackToHome = () => {
  router.push({ name: "Home" });
}

const __returned__ = { handleBackToHome }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})